import { useMutation, useQuery } from '@tanstack/react-query';

import { getXeroInvoiceConnect } from '../api';
import { xeroInvoiceMutationKeys, xeroInvoiceQueryKeys } from '../data';

export const useXeroInvoiceConnect = () => {
  const mutation = useMutation({
    mutationKey: xeroInvoiceMutationKeys.connect,
    mutationFn: getXeroInvoiceConnect,
  });

  return mutation;
};

export const useXeroInvoiceOAuthCompletion = (params?: {
  code?: string;
  company_id?: string;
}) => {
  const query = useQuery({
    queryKey: [
      ...xeroInvoiceQueryKeys.connect,
      params?.code,
      params?.company_id,
    ],
    queryFn: () => getXeroInvoiceConnect(params),
    enabled: Boolean(params?.code || params?.company_id),
  });

  return query;
};
